import React from 'react';
import 'react-slideshow-image/dist/styles.css'
import {default as Links} from "../../../Route";

const  Home = () => {
    return (
        <>
            <section id="AnimatedBg" className="home bg-animate home-container-2">
                <div className="home-container  grid-padding">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-8">
                                <h2 className="title-one">Bienvenue sur le portail web des Anciens Etudiant Congolais de l'IAI (Institut Africain d'Informatique)</h2>
                                <a href={Links.Contact.link} className="btn btn-primary">{Links.Contact.label}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="featuresk" className="grayp" style={{
                padding: '0',
                marginTop: '2%',
            }}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12  title-section">
                            <h4 className="">
                                Notre motivation c'est de rassembler les anciens étudiants Congolais de l'IAI
                                et promovoir les TIC sur l'étendue du territoire national.
                            </h4>
                        </div>
                    </div>
                </div>
            </section>

            <section id="features" className="gray">
                <div className="container">
                    <div className="row">
                        <div className="col-md-10 col-md-offset-1 title-section">
                            <h4 className="title">
                                <span><a href={Links.Activities.link}>{Links.Activities.label}</a> </span>
                                Les principales
                            </h4>
                            <div className="line"><i className="icon icon-24 icon-trophy"></i></div>
                        </div>
                    </div>
                    <div className="row wrap-feature-two">
                        <div className="col-md-4">
                            <ul className="feature-two left">
                                <li>
                                <i className="icon icon-64 icon-tablet"></i>
                                <h5>Formations</h5>
                                <p>
                                    Réaliser des formations certifiantes dans le domaine des TIC sur l’entendue
                                    nationale et internationale
                                </p>
                            </li>
                                <li>
                                    <i className="icon icon-64 icon-clipboard"></i>
                                    <h5>Applicatifs</h5>
                                    <p>
                                        Concevoir et développer des applicatives aux besoins des usagers
                                    </p>
                                </li>
                            </ul>
                        </div>
                        <div className="col-md-4">
                            <img src="assets/images/features/man.png" className="img-responsive img-feature-two" alt=""/>
                        </div>
                        <div className="col-md-4">
                            <ul className="feature-two right">
                                <li>
                                    <i className="icon icon-64 icon-rocket"></i>
                                    <h5>Promotion des TIC</h5>
                                    <p>
                                        Promouvoir des TIC sur tout l’étendue du pays
                                    </p>
                                </li>
                                <li>
                                    <i className="icon icon-64 icon-gamecontroller"></i>
                                    <h5>Promotion des talents</h5>
                                    <p>
                                        Promouvoir des talents et des activités de l’association
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <section id="blog" className="">
                <div className="container">
                    <div className="row">
                        <div className="col-md-10 col-md-offset-1 title-section">
                            <h4 className="title">
                                <span><a href="#">Vos référents</a></span>
                            </h4>
                            <div className="line"><i className="icon icon-24 icon-compose"></i></div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="table-price info">
                                <div className="title-price">
                                    <img src="assets/images/gallery/mouvoulou.jpeg" className="thumbnail img-responsive" alt="mouvoulou"/>
                                </div>

                                <div className="content-post">
                                    <h5 className="mt-3"><a href="#" >Harvey BILILI MOUVOULOU</a></h5>
                                    <ul className="meta-post">
                                        <li><a target="_blank" href="tel:+242064302852"><span className="fa fa-phone-square fa-2x"></span>+242 06 430 28 52</a></li>
                                        <li><a href="#"><span className="fa fa-facebook fa-2x"></span></a></li>
                                        <li><a target="_blank" href="https://www.linkedin.com/in/harvey-mouvoulou-44748636"><span className="fa fa-linkedin fa-2x"></span></a></li>
                                    </ul>
                                    <ul className="text-one">
                                        <li className="align-center mb-3">Président de l'association</li>
                                        <li><span className="italic-label">Fonction : </span>Ingénieur informaticien</li>
                                        <li><span className="italic-label">Travail chez :</span> <a target="_blank" title="Agence Congolaise des Systèmes d'Information" href="#">ACSI (Agence Congolaise des Systèmes d'Information)</a></li>
                                        <li><span className="italic-label">Pays de résidence : </span>République du Congo</li>
                                        <li><span className="italic-label">Email : </span><a href="mailto:president@association-iaicongo.org">president@association-iaicongo.org</a></li>
                                    </ul>
                                </div>

                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="table-price info">
                                <div className="title-price">
                                    <img src="assets/images/gallery/francine.jpeg" className="thumbnail img-responsive" alt="francine"/>
                                </div>
                                <div className="content-post mt-3">
                                    <h5 className="mt-3"><a href="#">Derucia Francine OYENE</a></h5>
                                    <ul className="meta-post">
                                        <li><a target="_blank" href="tel:+242069163259"><span className="fa fa-phone-square fa-2x"></span>+242 06 916 32 59</a></li>
                                        <li><a target="_blank" href="#"><span className="fa fa-facebook fa-2x"></span></a></li>
                                        <li><a target="_blank" href="https://www.linkedin.com/in/francine-derucia-58529a228"><span className="fa fa-linkedin fa-2x"></span></a></li>
                                    </ul>
                                    <ul className="text-one">
                                        <li className="align-center mb-3">Trésorier et Comptable</li>
                                        <li><span className="italic-label">Fonction : </span>Administrateur des systèmes de Douanes</li>
                                        <li><span className="italic-label">Travail chez :</span> <a target="_blank" href="#">Douanes Congolaise</a></li>
                                        <li><span className="italic-label">Pays de résidence : </span>République du Congo</li>
                                        <li><span className="italic-label">Email : </span><a href="mailto:account-manager@association-iaicongo.org">account-manager@association-iaicongo.org</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="table-price info">
                                <div className="title-price">
                                    <img src="assets/images/gallery/google.jpeg" className="thumbnail img-responsive" alt="gamath"/>
                                </div>
                                <br/>
                                <br/>
                                <br/>
                                <br/>
                                <div className="content-post">
                                    <h5 className="mt-3"><a href="#">Fidèle Cheribeau BOUNGOU</a></h5>
                                    <ul className="meta-post">
                                        <li><a target="_blank" href="#"><span className="fa fa-facebook fa-2x"></span></a></li>
                                        <li><a target="_blank" href="#"><span className="fa fa-linkedin fa-2x"></span></a></li>
                                    </ul>
                                    <ul className="text-one">
                                        <li className="align-center mb-3">Responsable développement des projets</li>
                                        <li><span className="italic-label">Fonction : </span>Chef de section administration des réseaux et des systèmes de Douanes</li>
                                        <li><span className="italic-label">Travail chez :</span> <a target="_blank" href="#">Douanes Congolaise</a></li>
                                        <li><span className="italic-label">Pays de résidence : </span>République du Congo</li>
                                        <li><span className="italic-label">Email : </span><a href="mailto:project-manager@association-iaicongo.org">project-manager@association-iaicongo.org</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Home;

